
import { supabase } from '@/integrations/supabase/client';

export type CommentMetrics = {
  contentId: string;
  count: number;
};

const commentsMetricsService = {
  async getCount(contentId: string, contentType: string): Promise<number> {
    try {
      // Use the correct table name based on content type
      const tableName = contentType === 'poll' ? 'poll_comments' : 'card_comments';
      
      // Use proper field name based on content type
      const idField = contentType === 'poll' ? 'poll_id' : 'card_id';
      
      // Add type assertion to avoid excessive type instantiation
      const result = await supabase
        .from(tableName as any)
        .select('id', { count: 'exact', head: true })
        .eq(idField, contentId);
      
      // Use type assertions to avoid deep instantiation errors
      const count = (result.count as number) || 0;
      const error = result.error;
      
      if (error) throw error;
      return count;
    } catch (error) {
      console.error('Error getting comments count:', error);
      return 0;
    }
  }
};

export default commentsMetricsService;
